<template>
	<div id="mapMain" class="mapForPic" style="width: 1700px; height: 700px"></div>
</template>

<script>
	import "echarts/map/js/china.js"
	import Gmap from "../map/js/fzTianmap.js";
	import Api from "../Serves/net-api.js";
	import Http from "../Serves/net-http.js";
	//import { getStore, setStore } from '@/utils/storage'
	import 'maptalks/dist/maptalks.css'
	import * as maptalks from 'maptalks'
	import { HeatLayer } from 'maptalks.heatmap';
	import TalksMap from '../map/js/initMapTalks.js'
	import { mapState, mapActions, mapMutations } from "vuex";
	export default {
		name: "Monitor",
		components: {},
		data() {
			return {
				Gmaps: new Gmap(),
				dialogMapDetail: false,
				dataTitle: '',
				TalksMap: new TalksMap(),
				dataTitleShow: true,
				runTimeDay: '',
				operatArea: '',
				currentDate: '',

				tabArr: [],
				isActive: 0,
				cityName: this.$store.state.info.govLevel === 1 ? '本市' : '',
				pointData1: [],
				pointData2: [],
				pointData5: [],
				allPointsData: [],
				setMarkersData: [],
				historyDialog: false,
				workDialog: false,
				imei: '',
				njId: '',
				collectTime: '',
				currentdateText: '',
				calendarFlag: true,
				startContinue: "start",
				operationForPauseAndContinue: "start",
				map: "",
				stopedIndex: 0,
				trackList: [],
				getGjTime: '',
				requestTimer: null,
				lastRequestData: [],
				statusStatic: true,
				zanting: require('/static/bofang/zanting.png'),
				kaishi: require('/static/bofang/start.png'),
				continueOrStopUrl: require('/static/bofang/start.png'),
				tingzhi: require('/static/bofang/tingzhi.png'),
				speedList: [{
					'speedTimes': '0.5X',
					'speed': 800,
				}, {
					'speedTimes': '1X',
					'speed': 400,
				}, {
					'speedTimes': '2X',
					'speed': 200,
				}, {
					'speedTimes': '3X',
					'speed': 133,
				}],
				speedIsActive: 1,
				popVisible: false,
				itemId: '',
				workType_key: '',
				njClassName: '',
				sourceId: '',
				source: ''
			}
		},
		beforeDestroy() {
			// 清除当前页定时器
			if(this.requestTimer) {
				clearInterval(this.requestTimer);
				this.timer = null;
			}
		},
		computed: {
			...mapState({
				handleName: state => state.kName,
			})
		},
		watch: {
			handleName(newVal, oldVal) {
				if(newVal == 'end') {
					this.operationForPauseAndContinue = 'start'
					document.getElementById("pauseBtns").innerHTML = "开始";
					this.continueOrStopUrl = this.kaishi;
					this.calendarFlag = true;
					this.popVisible = false;
				}
			}
		},
		created() {
			let _this = this;
			window.viewHistory = _this.viewHistory;
			window.viewCurrentLine = _this.viewCurrentLine;
		},
		mounted() {
			let this_ = this;

			let url = location.href;
			var reg = /[?&]([^?&#]+)=([^?&#]+)/g;
			var param = {};
			var ret = reg.exec(url);
			while(ret) { // 当ret为null时表示已经匹配到最后了，直接跳出
				param[ret[1]] = ret[2];
				ret = reg.exec(url);
			}
			this.param = param
			this.initMapTalk()

		},
		methods: {

			// 获取区县边界
			getCityBorderByViewCenter() {
				let level;
				if(Object.keys(this.param)[0] == 'provCode') {
					level = 1
				} else if(Object.keys(this.param)[0] == 'cityCode') {
					level = 2
				} else if(Object.keys(this.param)[0] == 'countryCode') {
					level = 3
				}
				var parmse = {
					adcode: Object.values(this.param)[0],
					level: level
				}
				Api.doPost(Http.gis.getCityBorderByViewCenter, parmse, false, (res) => {
					let Coordinate = {
						x: res.result.properties.lng,
						y: res.result.properties.lat
					};
					this.TalksMap.map.setCenter(Coordinate);
					this.TalksMap.drawCountyLine(res.result.geometry)

				})
			},
			// 初始化地图
			initMapTalk() {
				let this_ = this
				this.TalksMap.init("mapMain")

				this.allPointLayer = new maptalks.VectorLayer('point').addTo(this.TalksMap.map)
				this.allHeatLayer = new HeatLayer('heat').addTo(this.TalksMap.map)

				function getRandomNumberByRange(start, end) {
					return Number((Math.random() * (end - start) + start).toFixed(2))
				}
				this.$nextTick(() => {
					this.getHeatLayer()

				})

				let noZoomLevel = new maptalks.control.Zoom({
					position: {
						'bottom': 10,
						'right': 10
					},
					slider: true,
					zoomLevel: true
				})
				this.TalksMap.map.addControl(noZoomLevel)

				this.TalksMap.map.setMinZoom(5);

				let zoom;

				if(this.$store.state.areaName == '江苏省') {
					zoom = 7.8
				} else {
					zoom = 6.8
				}
				this.TalksMap.map.setZoom(zoom);

				this.$nextTick(() => {
					setTimeout(() => {
						this_.getCityBorderByViewCenter()
					})
				})

				//  级别变化事件
				//  级别变化事件
				this.TalksMap.map.on('zoomend', function(e) {
					this_.zoomEnd = e.to
					if(e.to >= 12) { //级别大于12加载地块
						if(this_.allPointLayer.getCount() == 0) {
							let data = this_.TalksMap.map.getExtent()
							this_.getMarkers(data)
						}

					}
					if(e.to < 12 && this_.allHeatLayer.getData().length > 0) { //级别小于16删除地块
						this_.allHeatLayer.show();
						this_.allPointLayer.clear();
					}

				})
				//  移动地图事件
				this.TalksMap.map.on('movestart', function(e) {
					this.startPoint = e.containerPoint || e.target.startPoint
				})
				this.TalksMap.map.on('moveend', function(e) { //移动地图结束，计算移动到一定距离加载地块
					this.endPoint = e.containerPoint || e.target.endPoint
					var a = this.startPoint ? this.endPoint.x - this.startPoint.x : 0
					var b = this.startPoint ? this.endPoint.y - this.startPoint.y : 0

					var c = Math.sqrt(a * a + b * b)

					if(c > 300 && this_.zoomEnd >= 12) {
						let data = this_.TalksMap.map.getExtent()
						this_.getMarkers(data)
					}
				})

			},
			// 更新实时位置信息接口
			updateCurrentLocation(imei) {
				Api.doPost(
					Http.gis.updateCurrentLocation, {
						type: 'gps',
						imei: imei,
						lat: 0,
						lng: 0
					},
					false,
					res => {
						console.log(res)
					})
			},

			// 获取热力图数据
			getHeatLayer() {
				var this_ = this;
				Api.doGet(
					Http.test + '/harvestProgress/noLogin/tendencyHeatMap?' + Object.keys(this.param)[0] + '=' + Object.values(this.param)[0], {}, res => {
						this.allData = res.data.result;
						this.setHeatLayer(0);
					}
				)

			},
			setHeatLayer() {
				this.allHeatLayer.show()
				this.allHeatLayer.setData(this.allData)
				let opt = {
					0.4: 'blue',
					0.6: 'cyan',
					0.9: 'yellow',
					1.0: 'red'
				}
				this.allHeatLayer.config({
					'radius': 5,
					'blur': 6,
					'gradient': opt
				})
			},
			// 获取markers数据
			getMarkers(data) {
				var this_ = this;
				Api.doPost(
					Http.homePageStatisByJSController.getCurrentGpsPoint, {
						xmin: data.xmin,
						ymin: data.ymin,
						xmax: data.xmax,
						ymax: data.ymax,
						ymax: data.ymax,
						catThreeCode: this.catThreeCode
					},
					false,
					res => {

						//         	this.pointData = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('其它')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						this.setMarkersData = res.result
						// 其它
						// this.pointData0 = res.result.workType_0 ? res.result.workType_0.map(function(data) {
						// 	data.vdata.push(data.imei)
						// 	data.vdata.push('其它')
						// 	data.vdata.push(data.status)
						// 	return data.vdata
						// }) : [];
						// // 拖拉机
						// this.pointData1 = res.result.workType_1 ? res.result.workType_1.map(function(data) {
						// 	data.vdata.push(data.imei)
						// 	data.vdata.push('拖拉机')
						// 	data.vdata.push(data.status)
						// 	return data.vdata
						// }) : [];
						// // 收获机
						// this.pointData2 = res.result.workType_2 ? res.result.workType_2.map(function(data) {
						// 	data.vdata.push(data.imei)
						// 	data.vdata.push('收获机')
						// 	data.vdata.push(data.status)
						// 	return data.vdata
						// }) : [];
						// // 插秧机
						// this.pointData5 = res.result.workType_5 ? res.result.workType_5.map(function(data) {
						// 	data.vdata.push(data.imei)
						// 	data.vdata.push('插秧机')
						// 	data.vdata.push(data.status)
						// 	return data.vdata
						// }) : [];
						// this.allPointsData = this.pointData1.concat(this.pointData2).concat(this.pointData5).concat(this.pointData0)
						// if(this.isActive == 0) {
						// 	this.setMarkersData = this.allPointsData;
						// } else if(this.isActive == 1) {
						// 	this.setMarkersData = this.pointData1;
						// } else if(this.isActive == 2) {
						// 	this.setMarkersData = this.pointData5;
						// } else if(this.isActive == 3) {
						// 	this.setMarkersData = this.pointData2;
						// } else if(this.isActive == 4) {
						// 	this.setMarkersData = this.pointData0;
						// }
						//						var arrnum = []
						//						var arrnum1 = []
						//						var arrnum2 = []
						//          var keys = ''
						//						if(this.itemId === '' || this.itemId === 'workType_') {
						//            for(var key in res.result) { //遍历对象的所有属性，包括原型链上的所有属性
						//								this.pointData1 = res.result[key] ? res.result[key].map(function(data) {
						//									data.vdata.push(data.imei)
						//									data.vdata.push('拖拉机')
						//									data.vdata.push(data.status)
						//									return data.vdata
						//								}) : [];
						//								this.pointData5 = res.result[key] ? res.result[key].map(function(data) {
						//									data.vdata.push(data.imei)
						//									data.vdata.push('插秧机')
						//									data.vdata.push(data.status)
						//									return data.vdata
						//								}) : [];
						//								this.pointData2 = res.result[key] ? res.result[key].map(function(data) {
						//									data.vdata.push(data.imei)
						//									data.vdata.push('收获机')
						//									data.vdata.push(data.status)
						//									return data.vdata
						//								}) : [];
						//								this.pointData3 = res.result[key] ? res.result[key].map(function(data) {
						//									data.vdata.push(data.imei)
						//									data.vdata.push('直播机')
						//									data.vdata.push(data.status)
						//									return data.vdata
						//								}) : [];
						//								this.pointData4 = res.result[key] ? res.result[key].map(function(data) {
						//									data.vdata.push(data.imei)
						//									data.vdata.push('植保机')
						//									data.vdata.push(data.status)
						//									return data.vdata
						//								}) : [];
						//								this.pointData0 = res.result[key] ? res.result[key].map(function(data) {
						//									data.vdata.push(data.imei)
						//									data.vdata.push('其它')
						//									data.vdata.push(data.status)
						//									return data.vdata
						//								}) : [];
						//            }
						//							this.setMarkersData = this.pointData1.concat(this.pointData2).concat(this.pointData3).concat(this.pointData4).concat(this.pointData5).concat(this.pointData0)
						//						} else {
						//							for(var key in res.result) { //遍历对象的所有属性，包括原型链上的所有属性
						//								if(res.result.hasOwnProperty(key)) { //判断是否是对象自身的属性，而不包含继承自原型链上的属性
						//									keys = key
						//									if(this.itemId === key) {
						//                  // this.allPointsData = res.result[key]
						//										if(this.tabArr.length === 5) {
						//											if(this.isActive == 1) {
						//												this.pointData1 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('拖拉机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData1;
						//											} else if(this.isActive == 2) {
						//												this.pointData5 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('插秧机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData5;
						//											} else if(this.isActive == 3) {
						//												this.pointData2 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('收获机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData2;
						//											} else if(this.isActive == 4) {
						//												this.pointData0 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('其它')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData0;
						//											}
						//										} else if(this.tabArr.length === 6) {
						//											if(this.isActive == 1) {
						//												this.pointData1 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('拖拉机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData1;
						//											} else if(this.isActive == 2) {
						//												this.pointData5 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('插秧机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData5;
						//											} else if(this.isActive == 4) {
						//												this.pointData4 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('植保机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData4;
						//											} else if(this.isActive == 3) {
						//												this.pointData2 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('收获机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData2;
						//											} else if(this.isActive == 5) {
						//												this.pointData0 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('其它')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData0;
						//											}
						//										} else if(this.tabArr.length === 7) {
						//											if(this.isActive == 1) {
						//												this.pointData1 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('拖拉机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData1;
						//											} else if(this.isActive == 2) {
						//												this.pointData5 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('插秧机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData5;
						//											} else if(this.isActive == 3) {
						//												this.pointData3 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('直播机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData3;
						//											} else if(this.isActive == 4) {
						//												this.pointData4 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('植保机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData4;
						//											} else if(this.isActive == 5) {
						//												this.pointData2 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('收获机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData2;
						//											} else if(this.isActive == 6) {
						//												this.pointData0 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('其它')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData0;
						//											}
						//										} else if(this.tabArr.length === 4) {
						//											if(this.isActive == 1) {
						//												this.pointData1 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('拖拉机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData1;
						//											} else if(this.isActive == 2) {
						//												this.pointData2 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('收获机')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData2;
						//											} else if(this.isActive == 3) {
						//												this.pointData0 = res.result[key] ? res.result[key].map(function(data) {
						//													data.vdata.push(data.imei)
						//													data.vdata.push('其它')
						//													data.vdata.push(data.status)
						//													return data.vdata
						//												}) : [];
						//												this.setMarkersData = this.pointData0;
						//											}
						//										}
						//									}　
						//								}
						//            }
						//						}
						// this_.setMarkers();
					}
				)
			},
			setMarkers() {
				let this_ = this;
				this.allHeatLayer.hide(); //隐藏热力图
				this.setMarkersData.forEach(function(item, index) {
					let lngLat = [item[0], item[1]];
					let imgUrl;

					imgUrl = require('../../static/img/mapIcon/tlj_icon.png')

					var point = new maptalks.Marker(
						item, {
							visible: true,
							editable: true,
							cursor: 'pointer',
							shadowBlur: 0,
							shadowColor: 'black',
							draggable: false,
							dragShadow: false, // display a shadow during dragging
							drawOnAxis: null, // force dragging stick on a axis, can be: x, y
							'symbol': [{
								'markerFile': imgUrl,
								'markerWidth': 40,
								'markerHeight': 57,
								'markerDx': 0,
								'markerDy': 0,
								'markerOpacity': 1
							}],
							properties: {
								id: item[4],
								obj: item[3]
							}
						}
					);
					point.on('click', this_.displayInfoWindow)
					point.addTo(this_.allPointLayer)
				})
			},
			// 关闭弹框
			dialogMapDetailClick() {
				this.dialogMapDetail = false
				this.historyDialog = false
				let childLayer = this.$refs.trackLayer;
				let childLayerMap = this.$refs.trackLayer.TalksMapDialog;
				if(childLayerMap._timer || childLayerMap.i > 0) {
					clearInterval(childLayerMap._timer);
					childLayerMap.i = 0
					childLayerMap._timer = ''
				}
				childLayerMap.lastLineLayer.clear()
				childLayerMap.carPoint.clear()
				childLayerMap.fist = true
				childLayerMap.lineLog = []
				childLayerMap.lastLinePoints = []
				childLayerMap.btnName = ''
				childLayer.operationForPauseAndContinue = 'start'
				document.getElementById("pauseBtns").innerHTML = "开始";
				childLayer.continueOrStopUrl = childLayer.kaishi;
				childLayer.calendarFlag = true
				if(this.requestTimer) {
					clearInterval(this.requestTimer);
					this.timer = null;
				}

			}
		}
	}
</script>

<style scoped>
	body {
		background: none;
	}
	/* 设置滚动条的样式 */
	
	::-webkit-scrollbar {
		width: 3px;
	}
	/* 滚动槽 */
	
	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
		border-radius: 10px;
	}
	/* 滚动条滑块 */
	
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: #0A63C6;
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
	}
	
	.tab-box {
		width: 98%;
		margin-left: 1%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
</style>


// WEBPACK FOOTER //
// src/components/mapForPic.vue